module.exports = __webpack_public_path__ + "img/Db.56c493b2.png";